<button
  [disabled]="loading() || disabled()"
  [ngClass]="{
    'button--fill': fill(),
    'button--loading': loading(),
  }"
  [type]="type()"
  class="button button--{{ variant() }}"
>
  <span class="button__label">
    <ng-content />
  </span>

  @if (loading()) {
    <app-spinner [loaderContrast]="loading()" class="button__loader" />
  }
</button>
